import { createApp } from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import { store } from "@/store";

import "ant-design-vue/dist/antd.css";

const app = createApp(App);

app.use(router);
app.use(Antd);
app.provide("$store", store);
app.use(store);

app.mount("#app");
